// @ts-expect-error not migrated to TS
import { getIsProductReadOnly } from 'EmailData/selectors/portalCritsitSelectors';
import { getHasAssignAssetAccess, getIsStarterEmail, getIsSuperAdminOrUser, getIsUngatedForAssignTeamInCreation, getShouldDisableCreateEmailAction, getUser // @ts-expect-error not migrated to TS
} from 'EmailData/selectors/user';
import useFetchDomains from 'EmailData/hooks/useFetchDomains';
import useFetchTeams from 'EmailData/hooks/useFetchTeams';
import { getEditorHref, getMergedEditorHref, getShouldShowEmailCreationModal } from 'EmailData/selectors/emailCreationSelectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CreateEmailButton from './CreateEmailButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateEmailButtonContainer({
  autoStartOnboarding,
  isDashboardEmptyState,
  overrideMergedEditorHref,
  use,
  emailCreationComponent,
  ButtonComponent
}) {
  const user = useSelector(getUser);
  const isStarter = useSelector(getIsStarterEmail);
  const mergedEditorHref = useSelector(state =>
  // @ts-expect-error type mismatch
  getMergedEditorHref(state, {
    autoStartOnboarding
  }));
  const isUngatedForAssignTeamInCreation = useSelector(getIsUngatedForAssignTeamInCreation);
  const hasAssignAssetAccess = useSelector(getHasAssignAssetAccess);
  const isSuperAdminOrUser = useSelector(getIsSuperAdminOrUser);
  const editorHref = useSelector(state =>
  // @ts-expect-error type mismatch
  getEditorHref(state, {
    autoStartOnboarding
  }));
  const canShowEmailCreationModal = useSelector(getShouldShowEmailCreationModal);
  const shouldShowEmailCreationModal = useMemo(() => {
    return canShowEmailCreationModal || isStarter;
  }, [canShowEmailCreationModal, isStarter]);
  const {
    teams,
    fetchTeamsLoading
  } = useFetchTeams(isSuperAdminOrUser);
  const {
    activeDomains
  } = useFetchDomains();
  return /*#__PURE__*/_jsx(CreateEmailButton, {
    autoStartOnboarding: autoStartOnboarding,
    editorHref: editorHref,
    fetchTeamsLoading: fetchTeamsLoading,
    mergedEditorHref: overrideMergedEditorHref || mergedEditorHref,
    hasActiveDomains: activeDomains.length > 0,
    hasEmailCreatePermission: user.canWrite(),
    hasAssignAssetAccess: hasAssignAssetAccess,
    isDashboardEmptyState: isDashboardEmptyState,
    isProductReadOnly: useSelector(getIsProductReadOnly),
    isUngatedForAssignTeamInCreation: isUngatedForAssignTeamInCreation,
    shouldDisableCreateEmailAction: useSelector(getShouldDisableCreateEmailAction),
    shouldShowEmailCreationModal: shouldShowEmailCreationModal,
    teams: teams,
    use: use,
    emailCreationComponent: emailCreationComponent,
    ButtonComponent: ButtonComponent
  });
}